import {
  CourseLicensePreviewObject,
  ValidatePlaceholderResponse
} from '@/jbi-shared/dto/jtms.dtos';
import { defaultApiState } from '@/store/types/general.types';
import { AxiosError } from 'axios';
import {
  CourseLicenseTemplateReplacer,
  CourseLicenseTemplateState,
  PaginatedCourseLicenseTemplate
} from './course-license-template.types';

export const courseLicenseTemplateMutations = {
  GET_AVAILABLE_REPLACERS_SUCCESS(
    state: CourseLicenseTemplateState,
    data: CourseLicenseTemplateReplacer[]
  ) {
    state.apiState.getAvailableReplacers = {
      ...defaultApiState,
      success: true
    };
    state.availableReplacers = data;
  },
  GET_AVAILABLE_REPLACERS_LOADING(state: CourseLicenseTemplateState) {
    state.apiState.getAvailableReplacers = {
      ...defaultApiState,
      loading: true
    };
    state.availableReplacers = undefined;
  },
  GET_AVAILABLE_REPLACERS_ERROR(
    state: CourseLicenseTemplateState,
    error: AxiosError
  ) {
    state.apiState.getAvailableReplacers = {
      ...defaultApiState,
      error
    };
  },

  GET_PAGINATED_COURSE_LICENSE_TEMPLATES_LOADING(
    state: CourseLicenseTemplateState
  ) {
    state.apiState.getPaginatedCourseLicenseTemplates = {
      ...defaultApiState,
      loading: true
    };
    state.paginatedCourseLicenseTemplates = undefined;
  },
  GET_PAGINATED_COURSE_LICENSE_TEMPLATES_SUCCESS(
    state: CourseLicenseTemplateState,
    data: PaginatedCourseLicenseTemplate
  ) {
    state.apiState.getPaginatedCourseLicenseTemplates = {
      ...defaultApiState,
      success: true
    };
    state.paginatedCourseLicenseTemplates = data;
  },
  GET_PAGINATED_COURSE_LICENSE_TEMPLATES_ERROR(
    state: CourseLicenseTemplateState,
    error: AxiosError
  ) {
    state.apiState.getPaginatedCourseLicenseTemplates = {
      ...defaultApiState,
      error
    };
  },

  VALIDATE_LICENSE_TEMPLATE_PLACEHOLDERS_SUCCESS(
    state: CourseLicenseTemplateState,
    data: ValidatePlaceholderResponse
  ) {
    state.apiState.validateLicenseTemplatePlaceholders = {
      ...defaultApiState,
      success: true
    };
    state.validatePlaceholderResponse = data;
  },
  VALIDATE_LICENSE_TEMPLATE_PLACEHOLDERS_LOADING(
    state: CourseLicenseTemplateState
  ) {
    state.apiState.validateLicenseTemplatePlaceholders = {
      ...defaultApiState,
      loading: true
    };
    state.validatePlaceholderResponse = undefined;
  },
  VALIDATE_LICENSE_TEMPLATE_PLACEHOLDERS_ERROR(
    state: CourseLicenseTemplateState,
    error: AxiosError
  ) {
    state.apiState.validateLicenseTemplatePlaceholders = {
      ...defaultApiState,
      error
    };
  },

  GENERATE_COURSE_LICENSE_PREVIEW_SUCCESS(
    state: CourseLicenseTemplateState,
    data: CourseLicensePreviewObject
  ) {
    state.apiState.generateCourseLicensePreviewFromTemplate = {
      ...defaultApiState,
      success: true
    };
    state.courseLicensePreview = data;
  },
  GENERATE_COURSE_LICENSE_PREVIEW_LOADING(state: CourseLicenseTemplateState) {
    state.apiState.generateCourseLicensePreviewFromTemplate = {
      ...defaultApiState,
      loading: true
    };
    state.courseLicensePreview = undefined;
  },
  GENERATE_COURSE_LICENSE_PREVIEW_ERROR(
    state: CourseLicenseTemplateState,
    error: AxiosError
  ) {
    state.apiState.generateCourseLicensePreviewFromTemplate = {
      ...defaultApiState,
      error
    };
  },

  CREATE_COURSE_LICENSE_TEMPLATE_LOADING(state: CourseLicenseTemplateState) {
    state.apiState.createCourseLicenseTemplate = {
      ...defaultApiState,
      loading: true
    };
  },
  CREATE_COURSE_LICENSE_TEMPLATE_SUCCESS(state: CourseLicenseTemplateState) {
    state.apiState.createCourseLicenseTemplate = {
      ...defaultApiState,
      success: true
    };
  },
  CREATE_COURSE_LICENSE_TEMPLATE_ERROR(
    state: CourseLicenseTemplateState,
    error: AxiosError
  ) {
    state.apiState.createCourseLicenseTemplate = {
      ...defaultApiState,
      error
    };
  },

  UPDATE_COURSE_LICENSE_TEMPLATE_LOADING(state: CourseLicenseTemplateState) {
    state.apiState.updateCourseLicenseTemplate = {
      ...defaultApiState,
      loading: true
    };
  },
  UPDATE_COURSE_LICENSE_TEMPLATE_SUCCESS(state: CourseLicenseTemplateState) {
    state.apiState.updateCourseLicenseTemplate = {
      ...defaultApiState,
      success: true
    };
  },
  UPDATE_COURSE_LICENSE_TEMPLATE_ERROR(
    state: CourseLicenseTemplateState,
    error: AxiosError
  ) {
    state.apiState.updateCourseLicenseTemplate = {
      ...defaultApiState,
      error
    };
  },

  DELETE_COURSE_LICENSE_TEMPLATE_LOADING(state: CourseLicenseTemplateState) {
    state.apiState.deleteCourseLicenseTemplate = {
      ...defaultApiState,
      loading: true
    };
  },
  DELETE_COURSE_LICENSE_TEMPLATE_SUCCESS(state: CourseLicenseTemplateState) {
    state.apiState.deleteCourseLicenseTemplate = {
      ...defaultApiState,
      success: true
    };
  },
  DELETE_COURSE_LICENSE_TEMPLATE_ERROR(
    state: CourseLicenseTemplateState,
    error: AxiosError
  ) {
    state.apiState.deleteCourseLicenseTemplate = {
      ...defaultApiState,
      error
    };
  }
};
